import api from "../lib/api";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator } from "./ui/dropdown-menu";
import { Download, FileSpreadsheet, FileText, FileDown, ChevronDown } from "lucide-react";

export default function ExportMenu({ dataset, testid = "export-menu" }) {
  const dl = (format) => window.open(`${api.defaults.baseURL}/export/${dataset}?format=${format}`, "_blank");
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid={testid} variant="outline" className="gap-2">
          <Download className="w-4 h-4" /> Export <ChevronDown className="w-3.5 h-3.5 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel>Download report</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid={`${testid}-excel`} onClick={() => dl("excel")}>
          <FileSpreadsheet className="w-4 h-4 mr-2 text-emerald-600" /> Excel (.xlsx)
        </DropdownMenuItem>
        <DropdownMenuItem data-testid={`${testid}-pdf`} onClick={() => dl("pdf")}>
          <FileText className="w-4 h-4 mr-2 text-rose-600" /> PDF report
        </DropdownMenuItem>
        <DropdownMenuItem data-testid={`${testid}-csv`} onClick={() => dl("csv")}>
          <FileDown className="w-4 h-4 mr-2 text-slate-500" /> CSV (raw)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
